import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit'
import { notification } from 'antd'
import { logout } from '@/features/auth/auth.slice.ts'
import { routes } from '@/utils/routes.ts'

export const unauthorizedMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    const payload = isRejectedWithValue(action)
      ? (action.payload as { data?: { errorCode?: string } })
      : null
    if (payload?.data?.errorCode === 'InvalidAuthToken') {
      notification.error({
        message: 'Invalid auth token. Logout in 3 seconds.',
      })
      setTimeout(() => {
        api.dispatch(logout())
        window.location.href = routes.logout
      }, 3000)
    }

    return next(action)
  }
